import { Query } from '@/app/tracking/api';
import { Bookmark } from './bookmark-state'

export interface QueryBookmarkTrackingQueryPayload {
}

export interface QueryBookmarkTrackingQueryResult {
  bookmark: Bookmark
}

export const QueryBookmarkTrackingQueryName = 'query-bookmark' as const
export type QueryBookmarkTrackingQuery =
      Query<typeof QueryBookmarkTrackingQueryName, QueryBookmarkTrackingQueryPayload, QueryBookmarkTrackingQueryResult>
